module fdm.flightLegsdg.lists {

    export class CockpitControlController {

        private queryResult: iteraFDM.domain.flightLegs.FlightTraceInfo;

        private query: iteraFDM.domain.flightLegs.FlightTraceQuery;
        private _cockpitElement: any;
        private lastCockpitFlag = false;

        get cockpitElement() {
            if (!this._cockpitElement) {
                this._cockpitElement = (this.$element[0].children[0] as any);
            }

            return this._cockpitElement;
        }

        public constructor(
            //private $window: ng.IWindowService,
            //private $timeout: ng.ITimeoutService,
            private $element: ng.IAugmentedJQuery,
            public $scope: ng.IScope
        ) {
            
        }

        $onChanges = (changes) => {
            if (changes.queryResult && changes.queryResult.currentValue) {

                this.initCockpit();
            }
        }

        private initCockpit() {
            if (this.queryResult) {
                //console.log(JSON.stringify(this.queryResult));
                this.cockpitElement.setCockpitOptions({
                    enable3DView: this.queryResult.enable3DView,
                    enable2DMapView: this.queryResult.enable2DMapView,
                    cesiumBaseUrl: '/digmo/vendors/flight-view/cesium',
                    cesiumAccessToken: this.queryResult.cesiumAccessToken,
                    googleMapsApiKey: this.queryResult.googleMapsApiKey,
                });
                this.cockpitElement.setData(this.queryResult);
                if (this.queryResult.navDataString) {
                    this.cockpitElement.setNavData(JSON.parse(this.queryResult.navDataString));
                }
                if (this.queryResult.metarDataString) {
                    this.cockpitElement.setMetarData(JSON.parse(this.queryResult.metarDataString));
                }
                let parameters = this.query.parameters.map(p => p.id);
                this.cockpitElement.setFlightTraceParameters(parameters);

                let currentCockpitFlag = this.query.cockpit;
                if (this.lastCockpitFlag != currentCockpitFlag) {
                    this.lastCockpitFlag = currentCockpitFlag;

                    if (currentCockpitFlag) {
                        this.cockpitElement.start();
                    } else {
                        this.cockpitElement.end();
                    }
                }
            } 
        }
    }

    angular.module('fdm.flightLegs').component('cockpitControl', {
        bindings: {
            queryResult: '<',
            query: '<'
        },
        controller: CockpitControlController,
        templateUrl: '/app/src/flight-legs/cockpit-control.html'
    });
}
